import { createSlice } from "@reduxjs/toolkit";
import { setAuthToken, setRefreshToken, clearAuthTokens } from "lib/api";
import { authUserDataHasId, getAuthToken, getRefreshToken } from "routes/auth";

export const sliceAuthUser = createSlice({
  name: "authUser",
  initialState: {
    data: {},
  },
  reducers: {
    fetched: (state, { payload }) => {
      const { user } = payload?.data || {};
      if (user !== undefined) state.data = user || {};
    },
    updated: (state, { payload }) => {
      const patch = payload?.data;
      if (!patch) return;
      state.data = state.data ? { ...state.data, ...patch } : { ...patch };
    },
    logout: (state) => {
      state.data = {};
    },
  },
});

const { fetched, updated, logout } = sliceAuthUser.actions;

export const SetAuthUserData = (payload) => async (dispatch) => {
  if (!payload) throw new Error("missing Data parameter");
  if (payload.token) setAuthToken(payload.token);
  if (payload.refreshToken) setRefreshToken(payload.refreshToken);
  dispatch(fetched({ data: { user: payload.user } }));
};

export const UpdateAuthUserData = (data) => async (dispatch) => {
  if (!data) throw new Error("missing Data parameter");
  dispatch(updated({ data }));
};

export const LogoutUser = () => (dispatch) => {
  clearAuthTokens();
  dispatch(logout({}));
};

export const selectAuthUser = (state) => state.AuthUser?.data ?? {};
/** Token lives only in localStorage — bridge for `useSelector` so UI updates after auth actions that dispatch. */
export const selectAuthToken = (_state) => getAuthToken();
export const selectRefreshToken = (_state) => getRefreshToken();
export const selectIsAuthenticated = (state) =>
  Boolean(getAuthToken() && authUserDataHasId(state.AuthUser?.data));

export default sliceAuthUser.reducer;
